export class FormTemplate {
    
}

export class FormInputTypes {

    static IMAGE = "image"
    static TEXTFIELD = "textfield"
    static DATE = "date"
    static CHECKBOX = "checkbox"

}